import { Icon } from '@chakra-ui/react';

export default function PlusNoCircleIcon(props) {
  return (
    <Icon
      width={5}
      height={5}
      viewBox='0 0 20 20'
      xmlns='http://www.w3.org/2000/svg'
      fill='currentColor'
      verticalAlign='center'
      {...props}
    >
      <path d='M4.62891 10.2998C4.62891 9.98079 4.89583 9.71387 5.20833 9.71387H9.42057V5.50814C9.42057 5.19564 9.68099 4.92871 10 4.92871C10.319 4.92871 10.5859 5.19564 10.5859 5.50814V9.71387H14.7917C15.1042 9.71387 15.3711 9.98079 15.3711 10.2998C15.3711 10.6188 15.1042 10.8792 14.7917 10.8792H10.5859V15.0915C10.5859 15.404 10.319 15.6709 10 15.6709C9.68099 15.6709 9.42057 15.404 9.42057 15.0915V10.8792H5.20833C4.89583 10.8792 4.62891 10.6188 4.62891 10.2998Z' />
    </Icon>
  );
}
